import React, { useState, useEffect } from "react";
import "./EditJobs.css";
import EditStore from "./EditStore";
import { useNavigate } from "react-router-dom";

function EditJobs() {
  const [searchQuery, setSearchQuery] = useState("");
  const [locationFilter, setLocationFilter] = useState("All");
  const [experienceFilter, setExperienceFilter] = useState("All");
  const [jobList, setJobList] = useState([]);
  const [filteredJobList, setFilteredJobList] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false); // For editing jobs
  const [showAddModal, setShowAddModal] = useState(false); // For adding new jobs
  const [editingJob, setEditingJob] = useState(null);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [applicationMessage, setApplicationMessage] = useState(""); // State for success message
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  // Access the API URL from environment variables
  const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

  const handleNavigate = () => {
    navigate("/MoreJobs"); // Redirect to the "Search More" page
  };

const [applicationForm, setApplicationForm] = useState({
  name: "",
  email: "",
  address: "",
  experience: "",
});

const handleApplicationInputChange = (e) => {
  const { name, value } = e.target;
  setApplicationForm((prevForm) => ({ ...prevForm, [name]: value }));
};

const submitApplication = () => {
  console.log("Application Submitted", applicationForm);
  alert("Application Submitted Successfully!");
  setShowApplicationForm(false); // Close the modal after submission
  setApplicationForm({
    name: "",
    email: "",
    address: "",
    experience: "",
  });
};

  const [newJob, setNewJob] = useState({
    title: "",
    company: "",
    location: "",
    experience: "",
    description: "",
  }); // State for the new job form

  const jobData = [
    {
      id: 1,
      title: "Associate Software Developer",
      company: "Doorva Labs",
      location: "India",
      experience: "1-3 years",
      description: "Develop and maintain web-based applications.",
    },
    {
      id: 2,
      title: "Software Engineer",
      company: "Company A",
      location: "New York",
      experience: "2-5 years",
      description: "Work on developing software applications.",
    },
    {
      id: 3,
      title: "Senior Software Engineer",
      company: "Company B",
      location: "San Francisco",
      experience: "5-8 years",
      description: "Lead a team of engineers to develop products.",
    },
    {
      id: 4,
      title: "Associate Software Developer",
      company: "Doorva Labs",
      location: "India",
      experience: "1-3 years",
      description: "Develop and maintain web-based applications.",
    },
  ];

  useEffect(() => {
    setJobList(jobData);
    setFilteredJobList(jobData);
  }, []);

  useEffect(() => {
    const filteredJobs = jobList.filter((job) => {
      const matchesQuery =
        job.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        job.company.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesLocation =
        locationFilter === "All" || job.location === locationFilter;
      const matchesExperience =
        experienceFilter === "All" || job.experience === experienceFilter;
      return matchesQuery && matchesLocation && matchesExperience;
    });

    setFilteredJobList(filteredJobs);
    setSuggestions(filteredJobs.slice(0, 5)); // Show only top 5 suggestions
  }, [searchQuery, jobList]);

  const handleEditClick = (job) => {
    setEditingJob(job);
    setShowEditModal(true);
  };

  const handleAddJobClick = () => {
    setShowAddModal(true); // Show the modal to add a new job
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (editingJob) {
      setEditingJob((prevJob) => ({ ...prevJob, [name]: value }));
    } else {
      setNewJob((prevJob) => ({ ...prevJob, [name]: value }));
    }
  };


  const handleSuggestionClick = (job) => {
    setSearchQuery(job.title); // Set the search query to the clicked suggestion
    setSuggestions([]); // Hide suggestions after selection
  };

  const saveEditedJob = () => {
    setJobList((prevJobs) =>
      prevJobs.map((job) =>
        job.id === editingJob.id ? editingJob : job
      )
    );
    setShowEditModal(false);
    setEditingJob(null);
  };

  const saveNewJob = () => {
    setJobList((prevJobs) => [
      ...prevJobs,
      { ...newJob, id: prevJobs.length + 1 },
    ]);
    setShowAddModal(false);
    setNewJob({
      title: "",
      company: "",
      location: "",
      experience: "",
      description: "",
    });
  };

  return (
    <>
    <div className="container-editjobs">
      <div className="jobs-page-container-editjobs">
        {/* Search Bar */}
        <div className="search-bar-editjobs">
          <input
            type="text"
            placeholder="Search for jobs..."
            className="search-input-editjobs"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="search-btn-editjobs"> 🔍</button>
        </div>

        {/* Search Suggestions */}
        {suggestions.length > 0 && searchQuery && (
          <div className="suggestions-list-editjobs">
            {suggestions.map((job) => (
              <div
                key={job.id}
                className="suggestion-item-editjobs"
                onClick={() => handleSuggestionClick(job)}
              >
                <p>{job.title}</p>
                <p>{job.company}</p>
              </div>
            ))}
          </div>
        )}
        
        {/* Filters */}
        <div className="filters-editjobs">
          <select
            onChange={(e) => setLocationFilter(e.target.value)}
            value={locationFilter}
          >
            <option value="All">All Locations</option>
            <option value="New York">New York</option>
            <option value="San Francisco">San Francisco</option>
            <option value="India">India</option>
          </select>
          <select
            onChange={(e) => setExperienceFilter(e.target.value)}
            value={experienceFilter}
          >
            <option value="All">All Experience Levels</option>
            <option value="1-3 years">1-3 years</option>
            <option value="2-5 years">2-5 years</option>
            <option value="5-8 years">5-8 years</option>
          </select>
        </div>

        {/* New Job Button */}
        <button className="new-job-btn-editjobs" onClick={handleAddJobClick}>
          + Add New Job
        </button>

        {/* Job Listings */}
        <div className="job-listings-editjobs">
          {filteredJobList.length > 0 ? (
            filteredJobList.map((job) => (
              <div key={job.id} className="job-card">
                <h3>{job.title}</h3>
                <p className="company-editjobs">{job.company}</p>
                <p className="location-editjobs">{job.location}</p>
                <p className="experience-editjobs">{job.experience}</p>
                <p className="description-editjobs">{job.description}</p>
                <button
                  className="apply-btn-editjobs"
                  onClick={() => setShowApplicationForm(true)}
                >
                  Apply Now
                </button>
                <button
                  className="edit-btn-editjobs"
                  onClick={() => handleEditClick(job)}
                >
                  Edit
                </button>
              </div>
            ))
          ) : (
            <p>No jobs found.</p>
          )}
        </div>

        {showApplicationForm && (
  <div className="modal-editjobs">
    <div className="modal-content-editjobs">
      <span
        className="close-editjobs"
        onClick={() => setShowApplicationForm(false)}
      >
        &times;
      </span>
      <h2>Apply for Job</h2>
      {applicationMessage && <p className="success-message-editjobs">{applicationMessage}</p>}
      <form>
        <label>Name:</label>
        <input
          type="text"
          name="name"
          value={applicationForm.name}
          onChange={handleApplicationInputChange}
        />

        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={applicationForm.email}
          onChange={handleApplicationInputChange}
        />

        <label>Address:</label>
        <textarea
          name="address"
          value={applicationForm.address}
          onChange={handleApplicationInputChange}
        ></textarea>

        <label>Experience:</label>
        <input
          type="text"
          name="experience"
          value={applicationForm.experience}
          onChange={handleApplicationInputChange}
        />

        <button
          type="button"
          onClick={submitApplication}
        >
          Submit Application
        </button>
      </form>
    </div>
  </div>
)}


        {/* Edit Job Modal */}
        {showEditModal && (
          <div className="modal-editjobs">
            <div className="modal-content-editjobs">
              <span
                className="close-editjobs"
                onClick={() => setShowEditModal(false)}
              >
                &times;
              </span>
              <h2>Edit Job</h2>
              <form>
                <label>Title:</label>
                <input
                  type="text"
                  name="title"
                  value={editingJob.title}
                  onChange={handleInputChange}
                />

                <label>Company:</label>
                <input
                  type="text"
                  name="company"
                  value={editingJob.company}
                  onChange={handleInputChange}
                />

                <label>Location:</label>
                <input
                  type="text"
                  name="location"
                  value={editingJob.location}
                  onChange={handleInputChange}
                />

                <label>Experience:</label>
                <input
                  type="text"
                  name="experience"
                  value={editingJob.experience}
                  onChange={handleInputChange}
                />

                <label>Description:</label>
                <textarea
                  name="description"
                  value={editingJob.description}
                  onChange={handleInputChange}
                ></textarea>

                <button
                  type="button"
                  onClick={saveEditedJob}
                >
                  Save Changes
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Add New Job Modal */}
        {showAddModal && (
          <div className="modal-editjobs">
            <div className="modal-content-editjobs">
              <span
                className="close-editjobs"
                onClick={() => setShowAddModal(false)}
              >
                &times;
              </span>
              <h2>Add New Job</h2>
              <form>
                <label>Title:</label>
                <input
                  type="text"
                  name="title"
                  value={newJob.title}
                  onChange={handleInputChange}
                />

                <label>Company:</label>
                <input
                  type="text"
                  name="company"
                  value={newJob.company}
                  onChange={handleInputChange}
                />

                <label>Location:</label>
                <input
                  type="text"
                  name="location"
                  value={newJob.location}
                  onChange={handleInputChange}
                />

                <label>Experience:</label>
                <input
                  type="text"
                  name="experience"
                  value={newJob.experience}
                  onChange={handleInputChange}
                />

                <label>Description:</label>
                <textarea
                  name="description"
                  value={newJob.description}
                  onChange={handleInputChange}
                ></textarea>

                <button
                  type="button"
                  onClick={saveNewJob}
                >
                  Save New Job
                </button>
              </form>
            </div>
          </div>
        )}
        <div className="search-more-container-editjobs">
          <button className="search-more-btn-editjobs" onClick={handleNavigate}>
            Search More ➡️
          </button>
        </div>
      </div>
    </div></>
  );
}

export default EditJobs;